import { render } from "./ItemAddAndRemoveButtons.vue?vue&type=template&id=64200c98&scoped=true"
import script from "./ItemAddAndRemoveButtons.vue?vue&type=script&lang=js"
export * from "./ItemAddAndRemoveButtons.vue?vue&type=script&lang=js"

import "./ItemAddAndRemoveButtons.vue?vue&type=style&index=0&id=64200c98&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64200c98"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip,QItemSection});
